import React from "react";
import EntityCrudPage from "../../appcomponents/EntityCrudPage";

const fields = [
  { name: "name", label: "Name", placeholder: "Publish / Draft / Schedule", autoSlugFrom: "name", required: true },
];

const columns = [
  { key: "name", label: "Name" },
  { key: "author", label: "Author", render: (row) => row.author || "-" },
];

export default function Status() {
  return (
    <EntityCrudPage
      title="Status"
      endpoint="/api/statuses.php"
      fields={fields}
      columns={columns}
      selectable
      viewFields={[...fields, { name: "author", label: "Author" }]}
      permissionPage="status"
    />
  );
}
